<div class="flex flex-grow min-h-160 h-full">
  <client-side-grid
    class="flex-1"
    [rowData]="rowData()"
    [columnDefs]="columnDefs()"
    [autoGroupColumnDef]="autoGroupColumnDef()"
    [pagination]="false"
    [loading]="groups.isLoading()"
    [noRowsOverlayComponent]="noRowsOverlay"
    [noRowsOverlayComponentParams]="noRowsOverlayParams"
    (cellClicked)="handleCellClick($event)"
    (gridReady)="onGridReady($event)"
    (filterChanged)="onFilterChanged($event)"
    [getMainMenuItems]="getMainMenuItems"
    [sideBar]="sideBarConfig"
    [gridOptions]="gridOptions"
  />
</div>
